import { render, staticRenderFns } from "./NotificationForm.vue?vue&type=template&id=7072fb75&scoped=true"
import script from "./NotificationForm.vue?vue&type=script&lang=js"
export * from "./NotificationForm.vue?vue&type=script&lang=js"
import style0 from "./NotificationForm.vue?vue&type=style&index=0&id=7072fb75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7072fb75",
  null
  
)

export default component.exports